import { Paragraph } from '@vimeo/iris/typography';

export default function ExactTarget() {
  return (
    <div>
      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
